import { render, staticRenderFns } from "./courseStudentManage.vue?vue&type=template&id=4a8e525e&scoped=true&"
import script from "./courseStudentManage.vue?vue&type=script&lang=js&"
export * from "./courseStudentManage.vue?vue&type=script&lang=js&"
import style0 from "./courseStudentManage.vue?vue&type=style&index=0&id=4a8e525e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e525e",
  null
  
)

export default component.exports